import axios from "axios";
import {
    setNotificationListLoading, setNotificationListSuccess, setNotificationListError,
    setGetNotificationLoading, setGetNotificationSuccess, setGetNotificationError,
    setCreateNotificationLoading, setCreateNotificationSuccess, setCreateNotificationError,

} from "../redux/reducer/notificationReducer";
import {
    setNotificationLoading,
    setNotificationSuccess,
    setNotificationError,
} from '../redux/reducer/authReducer'
import { errorHandler } from "../utils/utils";


const GENERAL_SERVICE = process.env.REACT_APP_GENERAL_SERVICE;

export const notificationListApi = async ({ token, dispatch, data }) => {
    dispatch(setNotificationListLoading());
    try {
        const res = await axios.post(`${GENERAL_SERVICE}/Notification/GetNotifications`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        dispatch(setNotificationListSuccess(res.data));
    } catch (err) {
        dispatch(setNotificationListError(err));
    }
}

export const getNotificationApi = async ({ token, id = 0, dispatch }) => {
    dispatch(setGetNotificationLoading());
    try {
        const res = await axios.get(`${GENERAL_SERVICE}/Notification/GetNotification/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        dispatch(setGetNotificationSuccess(res.data));
    } catch (err) {
        dispatch(setGetNotificationError(err))
    }
}
export const getNotificationDetailsApi = async ({ token, id = 0, dispatch }) => {
    try {
        const res = await axios.get(`${GENERAL_SERVICE}/Notification/GetNotificationDetail/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        return res.data;
    } catch (err) {
        return err;
    }
}
export const getSentStudentsNotificationApi = async ({ token, data, dispatch }) => {
    try {
        const res = await axios.post(`${GENERAL_SERVICE}/Notification/GetSendNotifications`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        return res.data;
    } catch (err) {
        return err;
    }
}

export const createNotificationApi = async ({ token, data, dispatch }) => {
    dispatch(setCreateNotificationLoading());
    try {
        const res = await axios.post(`${GENERAL_SERVICE}/Notification/${data.id ? "Edit" : "Create"}`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        dispatch(setCreateNotificationSuccess(res.data));
    } catch (err) {
        errorHandler(err, data, `${GENERAL_SERVICE}/Notification/${data.id ? "Edit" : "Create"}`)
        dispatch(setCreateNotificationError(err))
    }
}

export const getAdminNotificationApi = async ({ token, data, dispatch }) => {
    dispatch(setNotificationLoading());
    try {
        const res = await axios.post(`${GENERAL_SERVICE}/Notification/GetAdminNotification`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        dispatch(setNotificationSuccess(res.data));
    } catch (err) {
        errorHandler(err, data, `${GENERAL_SERVICE}/Notification/GetAdminNotification`)
        dispatch(setNotificationError(err))
    }
}

export const getReadNotificationApi = async ({ token, id = 0, dispatch }) => {
    try {
        const res = await axios.get(`${GENERAL_SERVICE}/Notification/ReadAllNotification`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
    } catch (err) {
    }
}


